




















































import {
  defineComponent,
  ref,
  computed,
} from '@vue/composition-api';
import { Popup } from '@hb/coffee';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { ubtSendError } from '@/shared/utils/ubt';
import titleSummaryImage from './images/title-summary@3x.png';

export default defineComponent({
  components: {
    Popup,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['confirm', 'cancel'],
  setup(props, context) {
    const closeablePopup = ref(false);
    const dependImageLoaded = ref(false);
    const onConfirm = () => {
      context.emit('confirm');

      ubtSetupPageButton('finance_loan_longItemPopup_chooseLongterm');
    };

    const onCancel = () => {
      context.emit('cancel');

      ubtSetupPageButton('finance_loan_longItemPopup_chooseShortterm');
    };

    const onLoadedMajorImage = () => {
      dependImageLoaded.value = true;
    };
    const onErrorMajorImage = () => {
      ubtSendError(new Error('majorImage load error'));

      dependImageLoaded.value = true;
    };

    return {
      closeablePopup,
      dependImageLoaded,
      onConfirm,
      onCancel,
      titleSummaryImage,
      onLoadedMajorImage,
      onErrorMajorImage,
      open: () => {
        /** do nothing */
      },
      close: () => {
        /** 用户从退出键触发关闭弹窗时，不切换还款期限 */
        context.emit('confirm');
      },
      isOpen: computed(() => props.visible),
    };
  },
});
